import types from '../mutation-types';
import ContactTasksAPI from '../../api/contactTasks';
import camelcaseKeys from 'camelcase-keys';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllTasksByContactId: _state => contactId => {
    const records = _state.records[contactId] || [];
    const contactTasks = records.sort((r1, r2) => r2.id - r1.id);
    return camelcaseKeys(contactTasks, { deep: true });
  },
};

export const actions = {
  async get({ commit }, { contactId }) {
    commit(types.SET_CONTACT_TASKS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ContactTasksAPI.get(contactId);
      commit(types.SET_CONTACT_TASKS, { contactId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_TASKS_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, { contactId, ...taskParams }) {
    commit(types.SET_CONTACT_TASKS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ContactTasksAPI.create(contactId, taskParams);
      commit(types.ADD_CONTACT_TASK, { contactId, data });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_TASKS_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { contactId, taskId, ...taskParams }) {
    commit(types.SET_CONTACT_TASKS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await ContactTasksAPI.update(
        contactId,
        taskId,
        taskParams
      );
      commit(types.UPDATE_CONTACT_TASK, { contactId, data });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_TASKS_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, { contactId, taskId }) {
    commit(types.SET_CONTACT_TASKS_UI_FLAG, { isDeleting: true });
    try {
      await ContactTasksAPI.delete(contactId, taskId);
      commit(types.DELETE_CONTACT_TASK, { contactId, taskId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_TASKS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_TASKS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_CONTACT_TASKS]($state, { data, contactId }) {
    $state.records = {
      ...$state.records,
      [contactId]: data,
    };
  },
  [types.ADD_CONTACT_TASK]($state, { data, contactId }) {
    const contactTasks = $state.records[contactId] || [];
    $state.records[contactId] = [...contactTasks, data];
  },
  [types.UPDATE_CONTACT_TASK]($state, { data, contactId }) {
    const contactTasks = $state.records[contactId] || [];
    $state.records[contactId] = contactTasks.map(task =>
      task.id === data.id ? data : task
    );
  },
  [types.DELETE_CONTACT_TASK]($state, { taskId, contactId }) {
    const contactTasks = $state.records[contactId] || [];
    $state.records[contactId] = contactTasks.filter(
      task => task.id !== taskId
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
